import { ApolloClient } from 'apollo-client';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { createUploadLink } from 'apollo-upload-client';
import { setContext } from 'apollo-link-context';
import { onError } from 'apollo-link-error';
import { ApolloLink } from 'apollo-link';
import { logout } from '../modules/auth/actions/auth';

export default class GraphQLClient {
  /**
   * @param {String} host  API Host URL
   * @param {String} store REACT store
   * @param {String} path  API GraphQL path
   * @param {String} token API JWT Token
   */
  constructor(host, store, path = '/', token = null) {
    this.store = store;
    this.token = token;

    const httpLink = new createUploadLink({ uri: `${host}${path}` });
    const authLink = setContext(this.onRequest.bind(this));
    const errorLink = onError(this.onError.bind(this));

    this.client = new ApolloClient({
      link: ApolloLink.from([
        errorLink,
        authLink,
        httpLink,
      ]),
      cache: new InMemoryCache(),
    });
  }

  /**
   * On request
   */
  onRequest(_, { headers }) {
    const { token } = this;

    return {
      headers: {
        ...headers,
        authorization: token ? `Bearer ${token}` : null,
      }
    }
  }

  /**
   * On error
   *
   * @param {Object} report
   *
   * @throws {Error}
   */
  onError(report) {
    const { networkError } = report;

    if (networkError && networkError.statusCode === 401) {
      this.store.dispatch(logout());
    }

    // if (graphQLErrors) {
    //   graphQLErrors.forEach(error => Sentry.captureException(new Error(error.message)));
    // }

    // if (networkError) {
    //   Sentry.captureException(new Error(networkError.message));
    // }
  }

  /**
   * Set token
   *
   * @param {String} token
   */
  setToken(token) {
    this.token = token;
  }

  /**
   * Execute the given query
   *
   * @param {Query}    query
   * @param {Object}   variables
   * @param {Function} success
   * @param {Function} failure
   * @param {Boolean}  force
   */
  query(query, variables = {}, success, failure, force = false) {
    const options = {};

    if (force) {
      options.fetchPolicy = 'network-only';
    }

    this.client.query({ query, variables, ...options }).then(success, failure).catch(failure);
  }

  /**
   * Execute the given mutation
   *
   * @param {Mutation} mutation
   * @param {Object}   variables
   * @param {Function} success
   * @param {Function} failure
   */
  mutate(mutation, variables, success, failure) {
    this.client.mutate({ mutation, variables }).then(success, failure).catch(failure);
  }

  /**
   * Clear the cache
   */
  clear(success) {
    this.client.resetStore().then(success);
  }
}



// WEBPACK FOOTER //
// ./src/api/GraphQLClient.js